import React from 'react';

export const DropDownStyles = () => (
  <style
    type='text/css'
    dangerouslySetInnerHTML={{
      __html: `
      body{
        // overflow: hidden;
      }

      div[role=listbox]{
        overflow-y:auto;
        height:95px;
        background-color: transparent;
      }

      .servicesDropDown div[role=listbox]{
        height:55px;
      }
    `,
    }}
  />
);
